import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const paymentMethodUri = config.apiEndpoints.paymentMethodUri
const paymentMethodTypeUri = config.apiEndpoints.paymentMethodTypeUri
export default {
    findAll: (searchOptions, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "page": page,
                "pageSize": pageSize,
                "keywords": searchOptions.keywords
            }
            HTTP.get(paymentMethodUri.concat('search'), { params: model }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (type) => {
        return new Promise((resolve, reject) => {
            HTTP.get(paymentMethodUri.concat(`${type && type > 0 ? `?type=${type}` : ''}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    allTypes: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(paymentMethodTypeUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(paymentMethodUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(paymentMethodUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(paymentMethodUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}